import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

import { Button } from "react-bootstrap";
import { getToken } from '../../utils/auth';

function TopupCheckoutLost({selectedCurrency, currencySymbol}) {
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const fetchPlans = async () => {
    try {
        const token = getToken();
      const response = await axios.get(`${process.env.REACT_APP_URL}/api/plan/top-up-rates/by-service-type?serviceType=sms&currency=${selectedCurrency}`, {
        headers: {
          accept: '*/*',
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("data", response.data.data)
      setPlans(response.data.data);
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };

  const initiatePayment = async () => {
    if (!selectedPlan) {
      toast.error('Please select a topup plan!');
      return;
    }
     const amount = selectedPlan.unitRate * quantity;
  
    if (amount <= 0) {
      toast.error('Amount cannot be zero.');
      return;
    }
    try {
      const payload = {
        amount: selectedPlan.unitRate * quantity,
        platform: 'lost-and-found',
        serviceType: selectedPlan.serviceType, 
        quantity,
      };
      const token = getToken();
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/payment/initiate-payment`, payload, {
        headers: {
          accept: '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      const paymentUrl = response.data.url; // Extract the URL from the API response
      if (paymentUrl) {
        window.location.href = paymentUrl; // Navigate to the payment page
      } else {
        toast.error('Failed to retrieve payment URL.');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
      toast.error(error?.response?.data?.message || 'Failed to initiate payment. Please try again.');
    }
  };
  
  

  useEffect(() => {
    fetchPlans();
  }, []);

  return (<>
<Toaster position="top-right" reverseOrder={false} style={{zIndex:"99999"}}/>


    <div>
      <Button onClick={() => setIsPopupVisible(true)}  style={{ width: '110px' }}>Topup Plan</Button>

      {isPopupVisible && (
        <div
  style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex:9999,
    padding: '20px', // Ensures space on smaller screens
    boxSizing: 'border-box',
  }}
>
  <div
    style={{
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      maxHeight: '90vh', // Dynamically adjust height
      width: '100%', // Full width on smaller screens
      maxWidth: '600px', // Restrict width on larger screens
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      overflowY: 'auto', // Enable scrolling for overflowing content
    }}
  >
            <h2>Select a Plan</h2>
            <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
              {plans?.map((plan) => (
                <div
                  key={plan?._id}
                  style={{
                    marginBottom: '15px',
                    border: `2px solid ${selectedPlan && selectedPlan._id === plan?._id ? '#007BFF' : '#ddd'}`,
                    padding: '10px',
                    borderRadius: '8px',
                    backgroundColor: selectedPlan && selectedPlan._id === plan?._id ? '#f0f8ff' : '#fff',
                  }}
                  onClick={() => {
                    setSelectedPlan(plan);
                    setQuantity(plan?.minimumQuantity || 1); 
                  }}                >
                  <h3>{plan?.serviceName} - {currencySymbol} {plan?.unitRate} unit rate</h3>
                  <div>
                    <strong>Service Type:</strong> {plan?.serviceType}
                  </div>
                 
                </div>
              ))}
            </div>
            {selectedPlan && (
              <div style={{ marginTop: '15px' }}>
                <h4>
                   Total Price - {currencySymbol}
                  {selectedPlan.unitRate * quantity}
                </h4>
               
                  <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: '10px',
        gap: '5px',
      }}
    >
        <label style={{fontSize:"16px"}}>Quantity:</label>
      {/* <div
        onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
        style={{
          width: '30px',
          height: '30px',
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          borderRadius: '4px',
          border: '1px solid #ddd',
          backgroundColor: '#f8f9fa',
          cursor: 'pointer',
        }}
      > */}
      <div
  onClick={() => 
    quantity > (selectedPlan?.minimumQuantity || 1) &&
    setQuantity((prev) => prev - 1)
  }
  style={{
    width: '30px',
    height: '30px',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: '4px',
    border: '1px solid #ddd',
    backgroundColor: quantity > (selectedPlan?.minimumQuantity || 1) ? '#f8f9fa' : '#e9ecef',
    cursor: quantity > (selectedPlan?.minimumQuantity || 1) ? 'pointer' : 'not-allowed',
  }}
>
        -
      </div>
      {/* <input
        type="number"
        value={quantity}
        min="1"
        onChange={(e) => setQuantity(Number(e.target.value))}
        style={{
          width: '60px',
          textAlign: 'center',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '2px',
          display:"flex",
          textAlign:"center",
          justifyContent:"center",
          alignItems:"center",
          fontSize: '14px',
        }}
      /> */}
      <input
  type="number"
  value={quantity}
  min={selectedPlan?.minimumQuantity || 1}
  onChange={(e) => 
    setQuantity(Math.max(selectedPlan?.minimumQuantity || 1, Number(e.target.value)))
  }
  style={{
    width: '60px',
    textAlign: 'center',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '2px',
    display: "flex",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    fontSize: '14px',
  }}
/>

      <div
        onClick={() => setQuantity((prev) => prev + 1)}
        style={{
          width: '30px',
          height: '30px',
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          borderRadius: '4px',
          border: '1px solid #ddd',
          backgroundColor: '#f8f9fa',
          cursor: 'pointer',
        }}
      >
        +
      </div>
    </div>
           
              </div>
            )}
            <div style={{ marginTop: '20px', justifyContent:"center", display:"flex" }}>
              <div
                onClick={initiatePayment}
                style={{
                    display:"flex",
                  marginRight: '10px',
                  padding: '10px',
                  justifyContent:"center",
                  backgroundColor: '#007BFF',
                  cursor:"pointer",
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width:"150px"
                }}
                disabled={!selectedPlan}
              >
                Proceed to Payment
              </div>
              <div
                onClick={() => setIsPopupVisible(false)}
                style={{
                    display:"flex",
                  padding: '10px 20px',
                  justifyContent:"center",
                  backgroundColor: '#6c757d',
                  cursor:"pointer",
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width:"150px"
                }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default TopupCheckoutLost;
